var toString = require('../lang/toString');

    /**
     * Searches for a given substring
     */
    function contains(str, substring, fromIndex){
        str = toString(str);
        substring = toString(substring);
        return str.indexOf(substring, fromIndex) !== -1;
    }

    module.exports = contains;





//////////////////
// WEBPACK FOOTER
// ./~/mout/string/contains.js
// module id = 1661
// module chunks = 0 1 2